/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Technologies_Meta_TitleInputs */

const en_us2_technologies_meta_title = /** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.name} Technology | egdata.app`)
};

const es_es2_technologies_meta_title = /** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Tecnología ${i?.name} | egdata.app`)
};

const ru_technologies_meta_title = /** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Технология: ${i?.name} | egdata.app`)
};

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const id_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const ms_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const da_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const de_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const es_mx2_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const fil_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const fr_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const it_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const hu_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const nl_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const no_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const pl_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const pt_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const pt_br2_technologies_meta_title = pt_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const ro_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const fi_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const sv_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const vi_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const tr_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const cs_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const bg_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const uk_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const ar_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const hi_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const th_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const ja_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const zh_cn2_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const zh_hant1_technologies_meta_title = en_us2_technologies_meta_title;

/** @type {(inputs: Technologies_Meta_TitleInputs) => LocalizedString} */
const ko_technologies_meta_title = en_us2_technologies_meta_title;

/**
* | output |
* | --- |
* | "{name} Technology \| egdata.app" |
*
* @param {Technologies_Meta_TitleInputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const technologies_meta_title = /** @type {((inputs: Technologies_Meta_TitleInputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Technologies_Meta_TitleInputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_technologies_meta_title(inputs)
	if (locale === "ms") return ms_technologies_meta_title(inputs)
	if (locale === "da") return da_technologies_meta_title(inputs)
	if (locale === "de") return de_technologies_meta_title(inputs)
	if (locale === "en-US") return en_us2_technologies_meta_title(inputs)
	if (locale === "es-ES") return es_es2_technologies_meta_title(inputs)
	if (locale === "es-MX") return es_mx2_technologies_meta_title(inputs)
	if (locale === "fil") return fil_technologies_meta_title(inputs)
	if (locale === "fr") return fr_technologies_meta_title(inputs)
	if (locale === "it") return it_technologies_meta_title(inputs)
	if (locale === "hu") return hu_technologies_meta_title(inputs)
	if (locale === "nl") return nl_technologies_meta_title(inputs)
	if (locale === "no") return no_technologies_meta_title(inputs)
	if (locale === "pl") return pl_technologies_meta_title(inputs)
	if (locale === "pt-BR") return pt_br2_technologies_meta_title(inputs)
	if (locale === "pt") return pt_technologies_meta_title(inputs)
	if (locale === "ro") return ro_technologies_meta_title(inputs)
	if (locale === "fi") return fi_technologies_meta_title(inputs)
	if (locale === "sv") return sv_technologies_meta_title(inputs)
	if (locale === "vi") return vi_technologies_meta_title(inputs)
	if (locale === "tr") return tr_technologies_meta_title(inputs)
	if (locale === "cs") return cs_technologies_meta_title(inputs)
	if (locale === "bg") return bg_technologies_meta_title(inputs)
	if (locale === "ru") return ru_technologies_meta_title(inputs)
	if (locale === "uk") return uk_technologies_meta_title(inputs)
	if (locale === "ar") return ar_technologies_meta_title(inputs)
	if (locale === "hi") return hi_technologies_meta_title(inputs)
	if (locale === "th") return th_technologies_meta_title(inputs)
	if (locale === "ja") return ja_technologies_meta_title(inputs)
	if (locale === "zh-CN") return zh_cn2_technologies_meta_title(inputs)
	if (locale === "zh-Hant") return zh_hant1_technologies_meta_title(inputs)
	return ko_technologies_meta_title(inputs)
});
export { technologies_meta_title as "technologies.meta.title" }